import request from '../request';

export const createToken = () =>
  request.post('tableau/token').then((res) => res)